import React from "react";
import Page from "@/layout/Page";

export default function Index() {
    return (
        <Page title="TERMS AND CONDITIONS">
            <p>Welcome to Myweed.club (&quot;the Site&quot;). By using the Site, you agree to these Terms and Conditions
                (&quot;Terms&quot;). If you do not agree to these Terms, you should not use the Site.</p>
            <h2>1. Use of the Site</h2>
            <p>
                The Site is intended for use only by persons who are of legal age to purchase and consume cannabis in
                their jurisdiction. By accessing and using the Site, you represent and warrant that you are of legal age
                to
                purchase and consume cannabis in your jurisdiction. We only accept those from in the United States at this time.
            </p>
            <h2>2. Compliance with Applicable Laws</h2>
            <p>You agree to comply with all applicable laws and regulations regarding the use of cannabis in your
                jurisdiction.
                You also agree to comply with any additional terms and conditions that may be imposed by the Site,
                including but
                not limited to restrictions on the use of the Site and the sale and distribution of cannabis.</p>
            <h2>3. Intellectual Property Rights</h2>
            <p>The Site and all content, information, and materials contained therein are the property of Myweed.club or
                its licensors, and are protected by applicable intellectual property laws. You may not reproduce,
                distribute, or use any content, information, or materials from the Site without the prior written
                consent of
                Myweed.club. When it comes to your personal information, it is YOURS. You can request to have your information removed at any
                time. Allow us 1 to 2 weeks to process. We require some forms of validation of who you say you are.</p>
            <h2>4. Disclaimer of Warranties</h2>
            <p>The Site is provided on an &quot;as is&quot; basis without warranty of any kind, either express or implied,
                including but
                not limited to the implied warranties of merchantability and fitness for a particular purpose.
                Myweed.club makes
                no representations or warranties regarding the accuracy, completeness, or reliability of the content or
                information on the Site.</p>
            <h2>5. Limitation of Liability</h2>
            <p>In no event shall Myweed.club be liable for any damages, including without limitation, indirect,
                incidental,
                special, or consequential damages, arising out of or in connection with the use or inability to use the
                Site or
                the content, information, or materials contained therein.</p>
            <h2>6. Indemnification</h2>
            <p>You agree to indemnify and hold harmless Myweed.club and its officers, directors, employees, agents, and
                affiliates from and against any and all claims, liabilities, damages, losses, costs, and expenses,
                including
                reasonable attorneys&apos; fees, arising out of or in connection with your use of the Site.</p>
            <h2>7. Governing Law and Jurisdiction</h2>
            <p>These Terms shall be governed by and construed in accordance with the laws of the state in which
                Myweed.club
                operates. Any dispute arising out of or in connection with these Terms shall be subject to the exclusive
                jurisdiction of the courts in that state.</p>
            <h2>8. Amendments</h2>
            <p>Myweed.club reserves the right to amend these Terms at any time by posting the amended Terms on the Site.
                Your
                continued use of the Site after any such amendments constitutes your acceptance of the amended
                Terms.</p>
            <h2>9. Severability</h2>
            <p>If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions shall
                remain in
                full force and effect.</p>

            <h2>10. Entire Agreement</h2>
            <p>These Terms constitute the entire agreement between you and Myweed.club with respect to the use of the
                Site and
                supersede all prior or contemporaneous communications and proposals, whether oral, written, or
                electronic,
                between you and Myweed.club with respect to the Site.</p>
        </Page>
    );
}